/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LastAgreement } from './LastAgreement';
import {
    LastAgreementFromJSON,
    LastAgreementFromJSONTyped,
    LastAgreementToJSON,
    LastAgreementToJSONTyped,
} from './LastAgreement';

/**
 * 
 * @export
 * @interface ClientOverviewResponse
 */
export interface ClientOverviewResponse {
    /**
     * 
     * @type {string}
     * @memberof ClientOverviewResponse
     */
    fullName: string;
    /**
     * 
     * @type {number}
     * @memberof ClientOverviewResponse
     */
    estimatedDebt: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClientOverviewResponse
     */
    estimatedNumberOfCreditors: number | null;
    /**
     * 
     * @type {LastAgreement}
     * @memberof ClientOverviewResponse
     */
    lastAgreement: LastAgreement | null;
}

/**
 * Check if a given object implements the ClientOverviewResponse interface.
 */
export function instanceOfClientOverviewResponse(value: object): value is ClientOverviewResponse {
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('estimatedDebt' in value) || value['estimatedDebt'] === undefined) return false;
    if (!('estimatedNumberOfCreditors' in value) || value['estimatedNumberOfCreditors'] === undefined) return false;
    if (!('lastAgreement' in value) || value['lastAgreement'] === undefined) return false;
    return true;
}

export function ClientOverviewResponseFromJSON(json: any): ClientOverviewResponse {
    return ClientOverviewResponseFromJSONTyped(json, false);
}

export function ClientOverviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientOverviewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fullName': json['fullName'],
        'estimatedDebt': json['estimatedDebt'],
        'estimatedNumberOfCreditors': json['estimatedNumberOfCreditors'],
        'lastAgreement': LastAgreementFromJSON(json['lastAgreement']),
    };
}

export function ClientOverviewResponseToJSON(json: any): ClientOverviewResponse {
    return ClientOverviewResponseToJSONTyped(json, false);
}

export function ClientOverviewResponseToJSONTyped(value?: ClientOverviewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fullName': value['fullName'],
        'estimatedDebt': value['estimatedDebt'],
        'estimatedNumberOfCreditors': value['estimatedNumberOfCreditors'],
        'lastAgreement': LastAgreementToJSON(value['lastAgreement']),
    };
}

